import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: ${variables.sectionPadding};

    .headline {
        font-size: 1.7em;
        font-weight: 700;
        color: #262626;
        text-align: center;
    }

    .groups {
        margin-top: 2em;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;

        &.only-one-group {
            justify-content: center;
            text-align: center;

            .group {
                margin-right: 0;
            }
        }

        .group {
            margin-bottom: 1em;
            margin-right: 1em;
            width: 18%;

            .group-title {
                color: #BA9449;
                font-weight: 700;
                padding-top: 1.5em;
                padding-bottom: .8em;
            }

            .group-values {
                display: flex;
                flex-direction: column;
                gap: .6em;

                .group-value {
                    text-decoration: none;
                    color: #000000;
                    cursor: pointer;

                    .value {
                        font-size: .85em;

                        &:hover {
                            text-decoration: underline;
                        }
                    }
                }
            }
        }
    }

    @media all and (max-width: ${variables.tabletS}) {
        .groups {
            .group {
                width: 30%;
            }
        }
    }

    @media all and (max-width: ${variables.mobileL}) {
        padding: ${variables.sectionPaddingMobile};

        .groups {
            font-size: 125%;

            .group {
                width: 45%;
            }
        }
    }
`;
